export const paths = {
	events: "/eventvue",
	autologin: "/autologin",
	login: "/login",
	signup: "/signup",
	home: "/",
	dashboard: "/dashboard",
	pricing: "/inventory",
	reports: "/reports",
	datavue: "/datavue",
	pricevue: "/pricevue",
	sales: "/sales",
	purchasing: "/purchasing",
	notification: "/notification",
	settings: "/settings",
	settingsAccount: "/settings/account",
	settingsAutoPricer: "/settings/auto-pricer",
	settingsLegal: "/settings/legal",
	settingsNotifications: "/settings/notifications",
	autoPO: "/autoPO",
	passwordManager: "/password-manager",
	creditCard: "/credit-card",
	newPO: "/new-po",
} as const;
